import { useBusinessContext } from '@context'
import { BusinessCountry } from '@query'

export const useShowDatevComingSoon = (): boolean => {
  const { data: business } = useBusinessContext()
  return business?.country === BusinessCountry.DE
}
